import React, { useCallback, useRef } from 'react';

export const useSyncedScroll = () => {
  const isSyncing = useRef(false);

  // Call this inside a useCallback body, never at render top-level.
  // Refs are only read when the event fires, not during render.
  const syncScroll = useCallback((scrollLeft: number, targets: React.RefObject<HTMLElement | null>[]) => {
    if (isSyncing.current) return;
    isSyncing.current = true;
    targets.forEach((ref) => {
      if (ref.current) ref.current.scrollLeft = scrollLeft;
    });
    setTimeout(() => {
      isSyncing.current = false;
    }, 0);
  }, []);

  return { syncScroll };
};
